import { Button, Popconfirm } from "antd";
import axios from "axios";
import React from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { deleteApigender } from "../../apifile/ApiFiles";

const GenderTable = ({ data, getGenderData, initialVlue, handleChange, reset }) => {
  const handleDeleteGender = async (id) => {
    try {
      const delet = await deleteApigender(id);
      // console.log(delet);
      getGenderData(1);
    } catch (error) { }
  };
  return (
    <>
      <div className="pageTable">
        <div className="tableLength d-flex form-search">

          <div className="dataTables_length">
            <input
              type="text"
              className="form-control"
              name="search"
              id="language_level"
              autoComplete="off"
              placeholder="search..."
              style={{ width: '600px' }}
              value={initialVlue?.search}
              onChange={handleChange}
            />
          </div>

          <div className="dataTables_length">
            <button type="button" className="btn btn-primary me-2" onClick={() => getGenderData(1)}>Search</button>
            <button type="button" className="btn btn-primary" onClick={() => reset(1)}>reset</button>
          </div>
        </div>
        <table className="table table-striped table-bordered ">
          <thead>
            {/* <tr role="row" className="filter">
              <td>
                <select
                  id="lang"
                  className="form-control"
                  defaultValue={"lang"}
                >
                  <option value>Select Language</option>
                  <option value="ar">عربى</option>
                  <option value="en" selected="selected">
                    English
                  </option>
                  <option value="es">Español</option>
                  <option value="ur">اردو</option>
                </select>
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  placeholder="Gender Area"
                />
              </td>
              <td>
                <select defaultValue={"Is Active"} className="form-select">
                  <option value={-1}>Is Active?</option>
                  <option value={1} selected="selected">
                    Active
                  </option>
                  <option value={0}>In Active</option>
                </select>
              </td>
            </tr> */}
            <tr role="row" className="heading">
              {/* <th>Language</th> */}
              <th>Gender</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.data?.map((item) => {
                return (
                  <tr role="row" className="odd">
                    {/* <td className="sorting_1">{item?.language_id?.lang}</td> */}
                    <td>
                      <span>{item?.gender}</span>
                    </td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-primary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Action
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link
                              className="dropdown-item"
                              // to="/admin/create-gender"
                              to={`/admin/edit-gender/${item._id}`}
                            >
                              Edit
                            </Link>
                          </li>

                          <li>

                            <Popconfirm
                              title="Delete the task"
                              description="Are you sure to delete this Gender?"
                              onConfirm={() => handleDeleteGender(item?._id)}
                              icon={
                                <QuestionCircleOutlined
                                  style={{
                                    color: "red",
                                  }}
                                />
                              }
                            >
                              <Button danger>Delete</Button>
                            </Popconfirm>
                          </li>
                          {/* <li>
                            <a className="dropdown-item" href="#">
                              Mark in Active
                            </a>
                          </li> */}
                        </ul>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default GenderTable;
